import React, { useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TournamentCard from '@/components/TournamentCard';
import type { TournamentCardFavorite } from '@/components/TournamentCard';
import { TournamentsListEmpty, TournamentsListView } from '@/components/TournamentsListView';
import { HeaderActionButton } from '@/components/ui';
import { useTournamentsListContext } from '@/layouts/TournamentsListLayout/context';
import type { Tournament } from '@/types';

const MyTournamentsTab: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(['tournament']);
  const { activeTab, isMobile } = useTournamentsListContext();

  const renderCard = useCallback((tournament: Tournament, favorite?: TournamentCardFavorite) => (
    <TournamentCard key={tournament.id} tournament={tournament} showUserStats favorite={favorite} />
  ), []);

  return (
    <TournamentsListView
      source="my"
      isActive={activeTab === 'my'}
      title={t('tournament:tournaments')}
      headerAction={isMobile ? (
        <HeaderActionButton onClick={() => navigate('/tournaments/create')} data-testid="tournaments-create-button">
          {t('tournament:create')}
        </HeaderActionButton>
      ) : undefined}
      renderCard={renderCard}
      emptyState={(
        <TournamentsListEmpty
          title={t('tournament:noTournamentsFound')}
          text={t('tournament:notParticipatingYet')}
          actions={(
            <>
              <button type="button" onClick={() => navigate('/tournaments/create')} className="ls-btn">
                {t('tournament:createTournament')}
              </button>
              <Link to="/tournaments/public" className="ls-btn ls-btn--outlined">
                {t('tournament:findTournaments')}
              </Link>
            </>
          )}
        />
      )}
    />
  );
};

export default MyTournamentsTab;
